import {
    Box,
    Paper,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Typography,
    useTheme,
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';
import Loader from 'src/components/loader/loader';
import ChangeQuantity from 'src/components/modal/ChangeQuantity';
import ImportExportDeviceModal from 'src/components/modal/ImportExportDeviceModal';
import { eventList, glb_sv, sendRequest, serviceList } from 'src/utils';
import crypt from 'src/utils/service/crypt';

const TableQuantityActionDevie = ({
    dataQuantity,
    idImportWareHouse,
    setVisibleQRCodeModal,
    fuctGet,
    setWarningImportExport,
    isImportWarehouse = false,
}) => {
    // console.log('TableQuantityActionDevie', dataDevice, dataQuantity);
    const { t } = useTranslation();
    const typeCabinet = useRef();
    const theme = useTheme();

    const dataProcessIOTRef = useRef([]);

    const chekcRef = useRef(false);
    const visibleRef = useRef('');
    const dataActionRef = useRef(null);
    const isEdit = useRef(false);
    const [isChecked, setIsChecked] = useState(false);
    const [visibleImport, setVisibleImport] = useState(false);
    const [visibleExport, setVisibleExport] = useState(false);

    const [actionDeviceOnline, setActionDeviceOnline] = useState(false);
    const actionRef = useRef();
    const [dataIE, setDataIE] = useState({});

    //Thêm vào giỏ (Lấy / Mượn) thiết bị
    const [visibleAddToCart, setVisibleAddToCart] = useState(false);
    const [note, setNote] = useState('');
    const [quantity, setQuantity] = useState('1');
    const [visibleRegisOnl, setVisibleRegisOnl] = useState(false);
    const navigate = useNavigate();

    const menu = sessionStorage.getItem('menu');
    let permissionBorrow = {};
    let permissionBorrowOnline = {};
    let permissionTake = {};
    let permissionTakeOnline = {};

    if (menu) {
        try {
            const data = JSON.parse(crypt.deCode(menu));
            // console.log('Loading menu', data[0]);
            permissionBorrow = data[0].filter((item) => item.screens_key === 'muon_tb')[0];
            permissionTake = data[0].filter((item) => item.screens_key === 'lay_tb')[0];
            permissionBorrowOnline = data[0].filter((item) => item.screens_key === 'muon_online')[0];
            permissionTakeOnline = data[0].filter((item) => item.screens_key === 'lay_online')[0];
        } catch (error) {}
    }

    //Nhập, xuất thiết bị
    useEffect(() => {
        setTimeout(() => {
            // getDataCabinet();
            checkStaticticalChecking();
        }, 1000);
        return () => {
            sessionStorage.removeItem('dataCabinet');
        };
    }, []);

    useEffect(() => {
        if (visibleExport || visibleImport) {
            window.addEventListener('beforeunload', handleBeforeUnload);
            window.addEventListener('unload', handleBeforeUnload);
        }
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
            window.removeEventListener('unload', handleBeforeUnload);
        };
    }, []);

    const handleBeforeUnload = (event) => {
        event.preventDefault();
        event.returnValue = '';
    };

    // check kiem ke
    const checkStaticticalChecking = useCallback(() => {
        if (chekcRef.current) {
            return;
        }
        chekcRef.current = true;
        const InVal = [1];
        sendRequest(
            serviceList.checkStatisticChecking,
            InVal,
            checkStaticticalCheckingResult,
            true,
            timeOutFunctcheckStaticticalChecking,
            40000
        );
    }, []);

    const checkStaticticalCheckingResult = (reqInfoMap, message) => {
        chekcRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setIsChecked(message.proc_data.rows[0].o_1[0].check_inv_status === '0' ? true : false);
        }
    };

    const timeOutFunctcheckStaticticalChecking = (reqInfo) => {
        chekcRef.current = false;
    };

    const handlleClickImport = (data) => {
        visibleRef.current = 'import';
        setDataIE(data);
        typeCabinet.current = data.cabinet_type;
        setVisibleImport(true);
        // openCell(data);
    };

    const handlleClickExport = (data) => {
        visibleRef.current = 'export';
        setDataIE(data);
        typeCabinet.current = data.cabinet_type;
        setVisibleExport(true);
        // openCell(data);
    };

    //Lấy hoặc mượn thiết bị offline
    const handleClick = (data) => {
        if (data?.qty > 0) {
            setDataIE(data);
            setVisibleAddToCart(true);
        } else {
            let str =
                data.status_action === '0'
                    ? t('warning_quantity') + ' ' + t('please_check_list_giver')
                    : t('warning_quantity');
            toast.warning(str);
        }
    };

    const generateUniqueId = () => {
        const uniqueId = Math.random().toString(36).substr(2, 9);
        return uniqueId;
    };

    const handleAddCatagory = (data, qty, note) => {
        if (data?.qty === 0) {
            return toast.warning(t('warning_quantity'));
        }
        const getSessions = sessionStorage.getItem('category');
        if (getSessions) {
            try {
                const arrCategories = JSON.parse(getSessions);
                arrCategories.push({
                    ...data,
                    qty: qty,
                    inventory: data.qty,
                    note: note,
                    idCategory: generateUniqueId(),
                    create_time: new Date().getTime(),
                });
                sessionStorage.setItem('category', JSON.stringify(arrCategories));
            } catch (error) {}
        } else {
            const arr = [];
            arr.push({
                ...data,
                qty: qty,
                inventory: data.qty,
                note: note,
                idCategory: generateUniqueId(),
                create_time: new Date().getTime(),
            });
            sessionStorage.setItem('category', JSON.stringify(arr));
        }
        glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
        toast.success(t('action_success_'), { position: 'top-left' });
        setVisibleQRCodeModal(false);
        navigate('/home/category/100');
    };

    //Lấy hoặc mượn thiết bị online (ebr: mượn, etk: lấy)
    const handleClickRegisOnl = (data) => {
        if (data?.qty > 0) {
            setDataIE(data);
            setVisibleRegisOnl(true);
        } else {
            let str =
                data.status_action === '0'
                    ? t('warning_quantity') + ' ' + t('please_check_list_giver')
                    : t('warning_quantity');
            toast.warning(str);
        }
    };

    const handleActionDevice = (data, qty, note, helper_device) => {
        if (actionRef.current) return;
        actionRef.current = true;
        const InVal = [
            0,
            data.cell_id,
            qty,
            'exp',
            data.status_action === '1' ? 'etk' : 'ebr',
            data.device_id,
            note,
            helper_device.id,
        ];
        sendRequest(serviceList.actionDeviceOnline, InVal, actionDeviceResult, true, timeOutFunctActionDevice, 40000);
    };

    const actionDeviceResult = (reqInfoMap, message) => {
        actionRef.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            glb_sv.commonEvent.next({ type: eventList.ADD_PRODUCT, data: 'add' });
            toast.success(message['proc_message'], { position: 'top-left' });
            setVisibleQRCodeModal(false);
            navigate('/home/category/100');
        }
    };

    const timeOutFunctActionDevice = (reqInfo) => {
        actionRef.current = false;
        toast.error(t('error.time_out'));
    };

    return (
        <>
            <ImportExportDeviceModal
                isEdit={isEdit.current}
                idPermission={idImportWareHouse?.id}
                visible={visibleImport}
                setVisible={setVisibleImport}
                importWarehouse
                dataUpdate={dataIE}
                idCabinet={dataIE?.cabinet_id}
                idDrawer={dataIE?.drawer_id}
                fuctGet={fuctGet}
                isQRCodeDevice
                typeCabinet={typeCabinet.current}
                isImport
            />
            <ImportExportDeviceModal
                idPermission={idImportWareHouse?.id}
                dataUpdate={dataIE}
                idCabinet={dataIE?.cabinet_id}
                idDrawer={dataIE?.drawer_id}
                fuctGet={fuctGet}
                visible={visibleExport}
                setVisible={setVisibleExport}
                isQRCodeDevice
                typeCabinet={typeCabinet.current}
            />
            <ChangeQuantity
                note={note}
                setnote={setNote}
                quantity={quantity}
                setQuantity={setQuantity}
                product={dataIE}
                callBackFunct={handleAddCatagory}
                visible={visibleAddToCart}
                setVisible={setVisibleAddToCart}
            />
            <ChangeQuantity
                note={note}
                setnote={setNote}
                quantity={quantity}
                setQuantity={setQuantity}
                product={dataIE}
                callBackFunct={handleActionDevice}
                visible={visibleRegisOnl}
                setVisible={setVisibleRegisOnl}
                isRegisterOnline
            />
            <Loader loading={actionDeviceOnline} />
            {dataQuantity?.length >= 1 && (
                <TableContainer component={Paper}>
                    <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell align="left">{t('info')}</TableCell>
                                <TableCell align="left">{t('quantity_category')}</TableCell>
                                <TableCell align="left"></TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {dataQuantity?.map((item, index) => (
                                <TableRow key={index}>
                                    <TableCell component="th" scope="row">
                                        <Stack display={'flex'} flexDirection={'column'}>
                                            <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                                                {t('cabinet')}: {item.cabinet_nm}
                                            </Typography>
                                            <Typography variant="subtitle3" noWrap>
                                                {t('drawer')}: {item.drawer_nm}
                                            </Typography>{' '}
                                            {item?.cabinet_type === 'square' ? (
                                                <Typography variant="subtitle3" noWrap>
                                                    {t('cell')}:{' '}
                                                    {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                                                </Typography>
                                            ) : (
                                                <Typography variant="subtitle3" noWrap>
                                                    {t('ordinal_number')}: {`[${item?.cell_lc?.column}]`}
                                                </Typography>
                                            )}
                                        </Stack>
                                    </TableCell>
                                    <TableCell align="left">{item.qty}</TableCell>
                                    <TableCell align="left">
                                        <Stack direction="row" alignItems="center" justifyContent="center">
                                            <Box
                                                sx={{
                                                    display: 'flex',
                                                    width: '100%',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    '& > *': {
                                                        m: 1,
                                                    },
                                                }}
                                            >
                                                {item?.device_nm && (
                                                    <>
                                                        {item?.min_no > item?.qty || item?.max_no <= item?.qty ? (
                                                            <>
                                                                {setWarningImportExport(true)}
                                                                <Tooltip
                                                                    title={
                                                                        item?.min_no > item?.qty
                                                                            ? t('warning_import')
                                                                            : t('warning_export')
                                                                    }
                                                                >
                                                                    <Iconify
                                                                        color={theme.palette.warning.main}
                                                                        icon="material-symbols:warning-outline-rounded"
                                                                    />
                                                                </Tooltip>
                                                            </>
                                                        ) : (
                                                            <>{setWarningImportExport(false)}</>
                                                        )}
                                                    </>
                                                )}
                                                {idImportWareHouse?.import_permission === '1' && (
                                                    <ButtonAction
                                                        title={t('import')}
                                                        disabled={
                                                            item?.block_status === '1' && item?.check_inv_status === '1'
                                                                ? false
                                                                : true
                                                        }
                                                        type="import"
                                                        onClick={() => handlleClickImport(item)}
                                                    />
                                                )}
                                                {idImportWareHouse?.export_permission === '1' && (
                                                    <ButtonAction
                                                        disabled={
                                                            item?.first_time === '0' &&
                                                            item?.block_status === '1' &&
                                                            item?.device_nm &&
                                                            item.check_inv_status === '1'
                                                                ? false
                                                                : true
                                                        }
                                                        title={t('export')}
                                                        type="export"
                                                        onClick={() => handlleClickExport(item)}
                                                    />
                                                )}
                                                {isImportWarehouse === false && (
                                                    <>
                                                        {((permissionBorrow?.search_permission === '1' &&
                                                            item.status_action !== '1') ||
                                                            (permissionTake?.search_permission === '1' &&
                                                                item.status_action === '1')) && (
                                                            <ButtonAction
                                                                fullWidth
                                                                // size="large"
                                                                type="get"
                                                                title={t('add_category')}
                                                                disabled={
                                                                    item?.first_time === '1' ||
                                                                    item?.check_inv_status === '0'
                                                                        ? true
                                                                        : false
                                                                }
                                                                onClick={() => handleClick(item)}
                                                            />
                                                        )}
                                                        {((permissionBorrowOnline?.search_permission === '1' &&
                                                            item.status_action !== '1') ||
                                                            (permissionTakeOnline?.search_permission === '1' &&
                                                                item.status_action === '1')) && (
                                                            <ButtonAction
                                                                fullWidth
                                                                // size="large"
                                                                type="other"
                                                                startIcon={
                                                                    item.status_action === '1' ? (
                                                                        <Iconify icon="material-symbols:download-for-offline-outline-rounded" />
                                                                    ) : (
                                                                        <Iconify icon="material-symbols:arrow-drop-down-circle-outline" />
                                                                    )
                                                                }
                                                                title={
                                                                    item.status_action === '1'
                                                                        ? t('lay_online_device')
                                                                        : t('muon_online_device')
                                                                }
                                                                disabled={
                                                                    item?.first_time === '1' ||
                                                                    item?.check_inv_status === '0'
                                                                        ? true
                                                                        : false
                                                                }
                                                                onClick={() => handleClickRegisOnl(item)}
                                                            />
                                                        )}
                                                    </>
                                                )}
                                            </Box>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}
        </>
    );
};

export default TableQuantityActionDevie;
